import type { Translate } from '@/shared/api/errors'

const TRANSFER_LOSS = /^Ko'chirish [0-9a-f-]{36}: (yo'lda shikastlangan|yetib kelmagan)$/

/**
 * Ko'chirish qabulida shikastlangan va yetib kelmagan qatorlarga server
 * o'zbekcha izoh va ko'chirish UUID sini yozadi. Ular panel matni bilan
 * almashtiriladi — hujjat raqami qatorning o'zida bor.
 */
export function movementReason(row: { kind: string; reason: string | null }, t: Translate): string | null {
  if (row.reason === null || !TRANSFER_LOSS.test(row.reason)) return row.reason
  return row.kind === 'DAMAGED' ? t('stock.transferReason.damaged') : t('stock.transferReason.missing')
}
